import { render, staticRenderFns } from "./PermissionManagementList.template.vue?vue&type=template&id=1a17a8b4&scoped=true&"
var script = {}
import style0 from "./PermissionManagementList.template.vue?vue&type=style&index=0&id=1a17a8b4&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a17a8b4",
  null
  
)

export default component.exports